import { clearTokens, userSignOut } from './auth';
import { Notification as customNotification } from '../components/ui/custom-notification';
import { SIGNOUT } from '../redux/types';

let isForceLogoutInProgress = false;

/**
 * Quietly clear auth state and redirect via ProtectedRoute when token is invalid.
 * Uses SIGNOUT (not SIGNOUT_SAGA) to avoid a misleading "Signed out successfully" toast.
 */
export const forceLogoutDueToInvalidToken = async ({ notify = true } = {}) => {
  if (isForceLogoutInProgress) {
    return;
  }

  isForceLogoutInProgress = true;

  try {
    if (notify) {
      customNotification.destroy();
      customNotification.error(
        'Session expired',
        'Your session is no longer valid. Please sign in again.'
      );
    }

    await clearTokens();

    try {
      // Dynamic import avoids circular deps with redux store ↔ axios configs
      const { getStore } = require('../redux/store');
      const store = getStore();
      if (store) {
        store.dispatch({ type: SIGNOUT });
      }
    } catch {
      // Store may not be ready during early bootstrap
    }

    try {
      await userSignOut();
    } catch {
      // Cognito sign-out is best-effort once tokens are cleared
    }
  } finally {
    setTimeout(() => {
      isForceLogoutInProgress = false;
    }, 1500);
  }
};
